export const SAVE = 'modules/video/SAVE';
export const SELECT = 'modules/video/SELECT';

